var escapeHTML = function (unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
var escapeRegExp = function (str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
/**
 * Returns the index of the last element in the array where predicate is true,
 * and -1 otherwise.
 *
 * @see Taken from {@link https://stackoverflow.com/a/53187807}.
 */
var findLastIndex = function (array, predicate) {
    var l = array.length;
    while (l--) {
        if (predicate(array[l], l, array)) {
            return l;
        }
    }
    return -1;
};
/** Modulo with support for negative numbers. */
var mod = function (x, n) { return ((x % n) + n) % n; };
/**
 * Generate a unique id on every invocation. Takes an optional prefix.
 * Like underscore's uniqueId.
 */
var generateUniqueId = (function () {
    var counter = 0;
    return function (prefix) { return "" + (prefix !== null && prefix !== void 0 ? prefix : "") + ++counter; };
})();
/**
 * Matches the default duolingo profile avatar
 */
var defaultAvatarPattern = /\/\/s3\.amazonaws\.com\/duolingo-images\/avatar\/[^/]*default/;

export { defaultAvatarPattern, escapeHTML, escapeRegExp, findLastIndex, generateUniqueId, mod };
